var $ = require('jquery');
var websiteData = require('diy/util/websiteData');

var config = {
    rest: {
        url: '/rest/websites/' + websiteData.getId() + '/semantic-data',
        mime: 'application/vnd.oneandone.diy.website.semantic-data+json',
        mimeValidation: 'application/vnd.oneandone.diy.website.semantic-data-validation+json',
        mimeConfiguration: 'application/vnd.oneandone.diy.website.semantic-data-configuration+json'
    },
    tr: {
        titles: ['honorificprefix', 'honorificsuffix'],
        phones: ['telephone', 'faxnumber']
    }
};

var cache, promiseCache;

var handlers = [];

var tr = jimdoData.messages.semanticdata;

/**
 * Executes all registered callbacks with the passed data.
 * @param {object} data
 * @private
 */
var callHandlers = function (data) {
    var i, len = handlers.length;
    for (i = 0; i < len; i++) {
        handlers[i](data);
    }
};

/**
 * Helper for phone number formatting.
 * @param {object|null} complex - Phone number parts or null if no data
 * @returns {string|null} - Formatted number or null if no data
 * @private
 */
var formatTelephoneNumber = function (complex) {
    if (complex === null || typeof complex !== 'object') {
        return null;
    }
    var bits = [];
    if (complex['countryPrefix']) {
        bits.push(complex['countryPrefix']);
    }
    if (complex['prefix']) {
        bits.push(complex['prefix']);
    }
    if (complex['number']) {
        bits.push(complex['number']);
    }
    return bits.join(' ');
};

/**
 * Helper for retrieving a translated label name, if available.
 * @private
 */
var trName = function (name) {
    var base = tr[name];
    if (!base) {
        return null;
    }
    if (base.label) {
        return base.label;
    }
    return null;
};

/**
 * Helper for retrieving a translated value, if available.
 * @private
 */
var trValue = function (name, value) {
    var base;

    base = config.tr.titles.indexOf(name) >= 0 ? tr.title : tr[name];
    if (!base) {
        return null;
    }
    if (!value) {
        return value;
    }
    if (base.value && base.value[value]) {
        return base.value[value];
    }
    return null;
};

/**
 * @param {object} data - Original data from server
 * @returns {object} - Processed data containing l10n
 * @private
 */
var localize = function (data) {
    var i, len, name, value, lname, lvalue;

    len = data.entities.length;

    for (i = 0; i < len; i++) {
        name = data.entities[i].name.replace('/', '').toLowerCase();
        value = data.entities[i].value;

        lvalue = lname = null;

        switch (value) {
            case 'dr':
                value = 'doctor_once';
                break;
            case 'prof':
                value = 'professor';
                break;
            case 'drdr':
                value = 'doctor_twice';
                break;
            case 'profdr':
                value = 'professor_combined';
                break;
        }

        lname = trName(name);

        if (config.tr.phones.indexOf(name) >= 0) {
            lvalue = formatTelephoneNumber(value);
        }
        else {
            lvalue = trValue(name, value);
        }

        data.entities[i].localizedName = lname;
        data.entities[i].localizedValue = lvalue;
    }
    return data;
};

/** @public */
var api = {

    /**
     * Delete the cache in order to force the API to refresh all data.
     */
    deleteCache: function () {
        cache = null;
        promiseCache = null;
    },

    /**
     * Fetches all data and returns one of:
     * - a resolved promise with the cache data if the cache is not empty;
     * - a promise of the ajax request with the response data if the cache is empty.
     * @returns {Promise}
     * @public
     */
    getAll: function () {
        if (cache) {
            var dfd = $.Deferred();
            setTimeout(function () {
                // resolve with a clone of the cache
                dfd.resolve($.extend(true, {}, cache));
            }, 0);
            return $.when(dfd);
        }

        promiseCache = promiseCache || $.when($.ajax({
            url: config.rest.url,
            type: 'GET',
            headers: {
                'Accept': config.rest.mimeConfiguration
            }
        }).done (function (data) {
            data = localize(data);
            cache = $.extend(true, {}, data);
            promiseCache = null;
        }));

        return promiseCache;
    },

    /**
     * Saves passed data and returns a promise of the ajax request.
     * On success, it calls all registered handlers.
     * @param {object}
     * @returns {promise}
     * @public
     */
    save: function (data) {
        // PLEASE NOTE that the backend is a REST interface; it will signal
        // errors as HTTP errors, so there is no need to explicitly check
        // return status
        return $.when($.ajax({
            url: config.rest.url,
            type: 'POST',
            contentType: config.rest.mime,
            headers: {
                'Accept': config.rest.mimeValidation
            },
            data: JSON.stringify(data),
            dataType: 'text'
        }).done(function () {
            // we use the given data because the REST endpoint does not provide it
            callHandlers(localize(data));
            // invalidate the data cache
            cache = null;
        }).fail(function (xhrResponse) {
            //XXX:DHDIY-26365: do not show black error for non-200 HTTP responses
            //FIXME: proper fix is to replace jQuery ajax() with a REST client which handles it properly
            xhrResponse.skipBlackError = true;
        }));
    },

    /**
     * Adds a function to be called upon save completion.
     * @param {function} callback
     * @returns {boolean}
     * @public
     */
    registerSaveHandler: function (callback) {
        var i, len;

        if (typeof callback !== 'function') {
            return false;
        }

        len = handlers.length;
        for (i = 0; i < len; i++) {
            if (handlers[i] === callback) {
                return false;
            }
        }
        handlers.push(callback);
        return true;
    }
};

module.exports = api;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/semanticdata/api/api.js
 ** module id = 8
 ** module chunks = 0 4
 **/